// extracted by mini-css-extract-plugin
export var divider = "_vj-0";